// (function($) {
//     $(".js-registrator__last").one('webkitAnimationEnd oanimationend msAnimationEnd animationend');

// })(jQuery);


// WEBPACK FOOTER //
// ./common.blocks/registrator/registrator.js